import { render, staticRenderFns } from "./RegisterCommon.vue?vue&type=template&id=17c7dd79&"
import script from "./RegisterCommon.vue?vue&type=script&lang=js&"
export * from "./RegisterCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports